import { createLink } from '@tanstack/react-router';

import { MenuItem, type MenuItemProps } from '@/libs/serenity-ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RouterMenuItemLink = createLink(({ className, ...props }: MenuItemProps<unknown> & { className?: string }) => <MenuItem {...props} />);
